function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHazzatOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 5.2916669 6.6145836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g870",
    transform: "matrix(0.99968201,0,0,1.0002586,4.3066231e-5,-4.2565857e-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1096-1",
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.296734,
      strokeLinecap: "square"
    },
    d: "M 0.14929117,0.14752088 H 5.1458599 V 6.4637455 H 0.14929117 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g862"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: "0.314043px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 0.95822984,4.7213334 H 4.0725917",
    id: "path11781"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: "0.314043px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 1.5657993,3.789443 H 4.6800998",
    id: "path11781-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: "0.314043px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 0.46780204,3.8008826 2.5908627,0.82157922",
    id: "path12318"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12344",
    style: {
      fill: "#343434",
      stroke: "#343434",
      strokeWidth: 0.944882,
      strokeLinecap: "square"
    },
    transform: "matrix(0.3112225,-0.02603612,0.02574546,0.31473617,-122.84199,-104.19449)",
    d: "m 372.23471,367.34592 -1.067,-0.9881 -1.067,-0.9881 1.38922,-0.42999 1.38922,-0.43 -0.32222,1.4181 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazzatOff);
export default __webpack_public_path__ + "static/media/hazzat_off.5709958204d01fda031e9232d3c53b0b.svg";
export { ForwardRef as ReactComponent };